<template>
  <div class="pl-3">
    <div class="flex items-center gap-x-3">
      <div>
        <TextInput v-model="form.search" @keydown.enter.native="applyFilter" placeholder="Customer name, orders:number,"></TextInput>
      </div>
      <div>
        <date-input v-model="form.delivery_date" @input="applyFilter"></date-input>
      </div>
      <div>
        <button @click="applyFilter" class="btn-primary py-2 h-8 px-3">
          Apply
        </button>
      </div>
      <div class="ml-5" v-if="form.delivery_date && pastCount > 0">
        <button @click="viewPastNotes" class="btn-primary py-2 h-8 px-3">Past Notes ({{ pastCount }}) </button>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from "@/Shared/TextInput.vue";
import DateInput from "@/Shared/DateInput.vue";

export default {
  name: 'QuickSearchOptions',
  components: {DateInput, TextInput},
  props: {
    filters: Object,
  },
  data() {
    return {
      pastCount: 0,
      form: {
        search: this.filters.search || null,
        order_number: this.filters.order_number || null,
        delivery_date: this.filters.delivery_date || null,
      },
    }
  },

  watch: {
    filters: {
      handler(v) {
        this.form = {
          search: v.search || null,
          order_number: v.order_number || null,
          delivery_date: v.delivery_date || null,
        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    applyFilter() {
      Object.assign(this.filters, this.form);
      this.$emit('apply');
    },

    viewPastNotes() {
      //get form.delivery_date
      //fetch past count from the form.delivery_date
    }
  }
}
</script>
